import React from "react";
import { ShieldCheck, Award, CircleCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QualityAssurance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="qualityassurance" ref={ref} className={`relative py-20 overflow-hidden bg-secondary text-secondary-foreground transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="relative flex flex-col items-center justify-center lg:items-start">
            <div className="relative group">
              {}
              <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-12 shadow-2xl transition-transform duration-500 hover:scale-[1.02]">
                <img src="https://mature-leech.10web.cloud/wp-content/uploads/2026/02/Accredited_Painter_Master_3D_Digital-scaled.jpg" alt="Dulux Accredited Painter Logo" className="w-full max-w-[280px] h-auto object-contain drop-shadow-lg" />
              </div>

              {}
              <div className="absolute -top-6 -right-6 animate-bounce duration-[3000ms]">
                <Badge variant="default" className="px-4 py-2 text-sm font-bold uppercase tracking-wider shadow-lg border-2 border-secondary">
                  <Award className="w-4 h-4 mr-2" />
                  Quality Assured
                </Badge>
              </div>

              {}
              <div className="absolute inset-0 border-2 border-primary/20 rounded-2xl -z-10 translate-x-4 translate-y-4" />
            </div>
          </div>

          {}
          <div className="space-y-8 text-center lg:text-left">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 text-primary font-semibold tracking-wide uppercase text-sm">
                <ShieldCheck className="w-5 h-5" />
                <span>Elite Craftsmanship</span>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-white">
                Dulux Accredited Painters
              </h2>
              <p className="text-lg text-secondary-foreground/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
                As a Dulux Accredited Painter, ANV Painting adheres to the
                highest industry standards. We combine meticulous surface
                preparation with premium products to deliver finishes that stand
                the test of time in the harsh North Queensland climate.
              </p>
            </div>

            {}
            <div className="bg-white/5 border-l-4 border-primary p-6 rounded-r-lg backdrop-blur-sm hover:bg-white/10 transition-colors duration-300">
              <h3 className="text-2xl font-bold text-primary mb-2 flex items-center justify-center lg:justify-start gap-3">
                <CircleCheck className="w-6 h-6" />
                7-Year Workmanship Guarantee
              </h3>
              <p className="text-secondary-foreground/90">We stand firmly behind our work. Every residential project is backed by our comprehensive 7-year workmanship warranty, giving you complete peace of mind that your investment is protected.</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
              <Link to="/GetAQuotePage" className="inline-flex items-center justify-center h-12 px-8 rounded-md bg-primary text-primary-foreground font-medium shadow-lg hover:bg-primary/90 transition-all hover:-translate-y-0.5">
                Request a Quote
              </Link>
              <Link to="/OurProcessPage" className="inline-flex items-center justify-center h-12 px-8 rounded-md border border-white/20 bg-transparent text-white font-medium hover:bg-white/10 transition-all">
                View Our Process
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}